import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Card, CardHeader, Container, Row, Button, Modal, ModalHeader, ModalBody, ModalFooter,Input } from "reactstrap";
import { getOrdersNotCollected,markCollected } from "network/ApiAxiosTickets"

import { AgGridColumn, AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { updateOrder } from "network/ApiAxiosTickets";

const EditOrders = () => {
  const history = useHistory();
  const [orders, setOrders] = useState();
  const [modal, setModal] = useState(false);
  const [orderToEdit, setOrderToEdit] = useState();
  const [reload, setReload] = useState("");
      const [selectedTicket, setSelectedTicket] = useState('');
      const [colorInput, setColorInput] = useState('');
      const [modalColor, setModalColor] = useState(false);
  
      const toggleColor = () => setModalColor(!modalColor);

  const role = JSON.parse(localStorage.getItem("user")).role

  const toggle = () => setModal(!modal);
  
  useEffect(() => { 
    const runAsync = async () => {
      const response = await getOrdersNotCollected("userTable");
      const { data } = response;
      if (data.success) {
        setOrders(data.doc);
      }
    };
    runAsync();
  }, [reload]);

  function editOrder(e) {
    setOrderToEdit(e.data)
    toggle()
  }

  const handleColor = async(ticketID)=>{
          const resp = await axios.post('https://new.geticketsonline.com/event/color/update', {ticketId: selectedTicket, color: colorInput})
          if(resp.data.success){
              toggleColor()
          }else{
              alert('Error updating color')
          }
      }

  const handleCollected = async(orderID)=>{
    
    const resp = await markCollected(orderID)
    console.log(resp.data)
    if(resp.data.success){
      toggle()
      setReload("go")
    }
  }


  const getRowStyle = (params) => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: "aliceblue" };
    }
  };

  const dynamicCellStyle = (params) => {
    if (params.value === false) {
      return { backgroundColor: "red" };
    } else {
      return { backgroundColor: "greenyellow" };
    }
  };
  const [gridApi, setGridApi] = useState(null);
  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handleReSend = async()=>{
    console.log(orderToEdit)
    const resp = await updateOrder(orderToEdit._id,orderToEdit.clientName,orderToEdit.phone)
    if(resp.data.success){
      alert('Message Sent!')
    }else{
      alert('Something went wrong!!')
    }
  }

  return (
    <>
      <Container>
        <Row>
          
          <div className="col">
            <Card className="shadow" style={{ width:"100%"}}>
              <CardHeader>
                <h2>Orders not Collected Past 7 days</h2>
                <p>Double click on order to mark as Collected</p>
              </CardHeader>
              <div className="ag-theme-alpine" style={{ height: 500, width:"100%"}}>
              
                <AgGridReact
                  rowData={orders}
                  animateRows={true}
                  onRowDoubleClicked={editOrder}
                  pagination={true}
                  paginationPageSize={20}
                  getRowStyle={getRowStyle}
                  onGridReady={onGridReady}
                  defaultColDef={{
                    flex: 1,
                    filter: true,
                    sortable: true,
                    floatingFilter: true,
                    columnHoverHighlight: true,
                    resizable: true,
                    suppressDragLeaveHidesColumns: false,
                  }}
                >
                  
                  <AgGridColumn field="clientName" minWidth="150" quickFilterText style={{textAlign:"center"}}></AgGridColumn>
                  <AgGridColumn field="phone" minWidth="200"></AgGridColumn>
                  <AgGridColumn field="totalNow" headerName="Total" minWidth="80" filter="agNumberColumnFilter"></AgGridColumn>
                  <AgGridColumn field="Seller.name" minWidth="150"></AgGridColumn>
                  <AgGridColumn
                    field="createdAt"
                    headerName="Date (Time add 1H)"
                    minWidth="200"
                  ></AgGridColumn>
                  <AgGridColumn
                    field="cart"
                    headerName="Cart"
                    minWidth="1900"
                  ></AgGridColumn>
                  
                </AgGridReact>
              </div>
            </Card>

            <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle}>Order</ModalHeader>
              <ModalBody className="text-center">
                {orderToEdit && <>
                  <h3>Seller:</h3> <p>{orderToEdit.Seller.name}</p>
                  <h3>Client Name:</h3> <p>{orderToEdit.clientName}</p>
                  <h3>Client Phone:</h3> <p>{orderToEdit.phone} <Button onClick={()=>handleReSend()}> Send QrCode</Button></p>
                  <h3>Cart:</h3> {orderToEdit.cart.map((cartItem,cartIndex)=>{
                    console.log('ppppp',cartItem,cartIndex)
                    return <div key={cartItem._id + cartIndex} onDoubleClick={()=>{setSelectedTicket(cartItem._id);toggle()}} style={{backgroundColor:cartItem.split('|')[2]}}><p style={{textShadow: '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff',fontWeight:'bold'}}>{cartItem.split('|')[0]} {cartItem.split('|')[1]} {/*cartItem.split('|')[0].includes('VIP') && cartItem.tableNumber */ }</p></div>
                  })}
                  {console.log(orderToEdit)}
                  <h3>Date:</h3> <p>{orderToEdit.createdAt}</p>
                  <h3>Total:</h3> <p>{orderToEdit.totalNow}</p>
                </>}
              </ModalBody>
              <ModalFooter>
                {role != 'sellermanager' && <Button color="primary" onClick={()=>handleCollected(orderToEdit._id)}>Mark Collected</Button>}
                <Button color="secondary" onClick={toggle}>Cancel</Button>
              </ModalFooter>
            </Modal>
            
            <Modal isOpen={modalColor} toggle={()=>toggleColor} className="modal-dialog-centered">
              <ModalHeader toggle={()=>toggleColor}>Bracelet Color</ModalHeader>
              <ModalBody>
                <Input type="text" onChange={(e)=>setColorInput(e.target.value)} value={colorInput} />
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={()=>handleColor()}>Save</Button>
                <Button color="secondary" onClick={()=>toggleColor()}>Close</Button>
              </ModalFooter>
            </Modal>

          </div>
        </Row>
      </Container>
    </>
  );
};

export default EditOrders;
